import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { cn } from "@/lib/utils";

export const Reveal = ({ children, delay = 0, className, y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children, className }) => (
  <div className={cn("flex items-center gap-3 font-mono text-[11px] tracking-[0.25em] text-crimson uppercase", className)}>
    <span className="h-px w-8 bg-crimson/60" />
    {children}
  </div>
);

// Shows the FINAL value by default; animates from ~70% only when scrolled into view,
// so screenshots / fast scrolls never catch a broken "0".
export const CountUp = ({ to, className, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(to);
  const started = useRef(false);

  useEffect(() => {
    if (!inView || started.current) return undefined;
    started.current = true;
    const from = Math.round(to * 0.7);
    if (from >= to) return undefined;
    const controls = animate(from, to, {
      duration: 1.4,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} className={className}>
      {val}
      {suffix}
    </span>
  );
};

export default Reveal;
